export const getMainColor = (template: 'lca' | 'mtx'): string => {
  if (template === 'lca') return '#6304f6'
  else return '#c0543a'
}

export const getFont = (template: 'lca' | 'mtx'): string => {
  if (template === 'lca') return 'Rubik'
  else return 'DM Sans'
}

export const getSecondaryColor = (template: 'lca' | 'mtx'): string => {
  if (template === 'lca') return '#fdfdfd'
  else return '#f9f4f1'
}
